import { HTTP_GET, WebApiRequest } from "tools/webservice";

// returns an array of queue entries that this case could be in
//{ controlIdNumber, queueTypeCode, takenDate }[]
// queueTypeCodes: "Homeowners QA", "Appraisal QA", "Field Appointment"
export const getQueueEntries = (controlIdNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/queue-entries/cases/${controlIdNumber}`,
  successCallback,
  mountedRef,
});
